/* eslint-disable */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DayPicker, { DateUtils } from 'react-day-picker';
import isEqual from 'lodash/isEqual';
import DropDown from '../../common/DropDown';
import { getParameterByName } from '../../../api/DataHandlers';

import history from '../../../history';

export default class DateDropDown extends Component {
    constructor(props) {
        super(props);
        const currentUrlParams = new URLSearchParams(history.location.search);
        this.state = {
            selectedDays: [],
            after: currentUrlParams.get('after')
                ? moment(currentUrlParams.get('after')).toDate()
                : null,
            before: currentUrlParams.get('before')
                ? moment(currentUrlParams.get('before')).toDate()
                : null,
            mouseDown: false,
        };

        this.onFilterChange = this.onFilterChange.bind(this);
        this.getSelectedDates = this.getSelectedDates.bind(this);
        this.getRangeSelection = this.getRangeSelection.bind(this);
        this.handleDayMouseDown = this.handleDayMouseDown.bind(this);
        this.handleDayMouseUp = this.handleDayMouseUp.bind(this);
        this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
    }

    componentDidMount() {
        this.props.data ? this.setDates(this.props) : null;
    }

    componentWillReceiveProps(nextProps) {
        const paramQuery = new URLSearchParams(history.location.search);
        const nextParamQuery = new URLSearchParams(
            nextProps.history.location.search,
        );
        let afterQuery;
        let beforeQuery;
        if (this.props.mode == 'payroll') {
            afterQuery = 'bookings_after';
            beforeQuery = 'bookings_before';
        } else {
            afterQuery = 'after';
            beforeQuery = 'before';
        }

        if (
            paramQuery.get(afterQuery) &&
            nextParamQuery.get(afterQuery) != this.state.after
        ) {
            this.setState({
                after: moment(nextParamQuery.get(afterQuery)).toDate(),
            });
        }

        if (
            paramQuery.get(beforeQuery) &&
            nextParamQuery.get(beforeQuery) != this.state.before
        ) {
            this.setState({
                    before: moment(nextParamQuery.get(beforeQuery)).toDate(),
                });
        }

        if (
            !paramQuery.get(beforeQuery) &&
            !paramQuery.get(afterQuery) &&
            !this.props.data
        ) {
            this.setState({
                after: moment().toDate(),
                before: moment().toDate(),
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.data && !isEqual(this.props.data, prevProps.data)) {
            this.setDates(prevProps);
        }
    }

    setDates = () => {
        const paramQuery = new URLSearchParams(history.location.search);

        const afterQuery = this.props.mode == 'payroll' ? 'bookings_after' : 'after'
        const beforeQuery = this.props.mode == 'payroll' ? 'bookings_before' : 'before'

        if (
            !paramQuery.toString() ||
            (!paramQuery.get(beforeQuery) && !paramQuery.get(afterQuery))
        ) {
            this.setState({
                after: moment().toDate(),
                before: moment().toDate(),
            });
        }
    };

    onFilterChange = dates => {
        let dateFormat = dates;
        if (this.props.mode == 'payroll') {
            dateFormat = {
                bookings_after: dates.after,
                bookings_before: dates.before,
            };
        }
        this.props.onFilterChange('dates', dateFormat);
    };

    getRangeSelection() {
        const paramQuery = new URLSearchParams(history.location.search);
        let after = moment(this.state.after);
        let before = moment(this.state.before);

        if (!before.isValid() || !after.isValid()) {
            return null;
        }

        [after, before] = before < after ? [before, after] : [after, before];
        after = after.set({ hour: 0 }).toDate().getTime();
        before = before.set({ hour: 23 }).toDate().getTime();

        const currentWeekStart = moment().startOf('isoWeek').toDate().getTime();
        const currentWeekEnd = moment().endOf('isoWeek').toDate().getTime();
        const lastWeekStart = moment()
            .subtract(1, 'weeks')
            .startOf('isoWeek')
            .toDate()
            .getTime();
        const lastWeekEnd = moment()
            .subtract(1, 'weeks')
            .endOf('isoWeek')
            .toDate()
            .getTime();
        const currentMonthStart = moment().startOf('month').toDate().getTime();
        const currentMonthEnd = moment().endOf('month').toDate().getTime();
        const lastMonthStart = moment()
            .subtract(1, 'months')
            .startOf('month')
            .toDate()
            .getTime();
        const lastMonthEnd = moment()
            .subtract(1, 'months')
            .endOf('month')
            .toDate()
            .getTime();

        const ret =
            after == currentWeekStart && before == currentWeekEnd
                ? 'currentweek'
                : after == lastWeekStart && before == lastWeekEnd
                ? 'lastweek'
                : after == currentMonthStart && before == currentMonthEnd
                ? 'currentmonth'
                : after == lastMonthStart && before == lastMonthEnd
                ? 'lastmonth'
                : paramQuery.get('getall')
                ? 'alldates'
                : null;

        return ret;
    }

    getSelectedDates() {
        const paramQuery = new URLSearchParams(history.location.search);
        let before = moment(this.state.before);
        let after = moment(this.state.after);

        if (paramQuery.has('getall') && paramQuery.has('bookings_after')) {
            return 'All dates';
        }
        if (!before.isValid() || !after.isValid()) {
            return moment().format('D MMMM YYYY');
        }
        [after, before] = before < after ? [before, after] : [after, before];

        if (
            paramQuery.get('getall') &&
            !paramQuery.get('before') &&
            !paramQuery.get('after')
        ) {
            return 'All dates';
        }
        if (
            !paramQuery.get('before') &&
            !paramQuery.get('after') &&
            paramQuery.get('getall')
        ) {
            return 'Select date';
        }
        if (before.format('DDMMYYYY') == after.format('DDMMYYYY')) {
            return before.format('D MMMM YYYY');
        }
        if (before.format('MMYYYY') == after.format('MMYYYY')) {
            return `${after.format('D')} \u2013 ${before.format(
                'D MMMM YYYY',
            )}`;
        }
        return `${after.format('D MMM. YYYY')} \u2014 ${before.format(
            'D MMM. YYYY',
        )}`;
    }

    handleDayMouseEnter(day, { nextMonth, previousMonth }) {
        // when you hoover days in calendar
        if (this.state.mouseDown) {
            this.setState({
                before: day,
            });

            if (nextMonth) {
                this.daypicker.showNextMonth();
            } else if (previousMonth) {
                this.daypicker.showPreviousMonth();
            }
        }
    }

    handleDayMouseDown(day, modifiers) {
        if (this.props.mode === 'payroll') {
            // select the whole week when one day in that week is clicked on payroll screen
            const after = moment(day).startOf('isoWeek').toDate();
            const before = moment(day).endOf('isoWeek').toDate();
            this.setState({
                after: after,
                before: before,
            });
        } else {
            this.setState({
                after: day,
                before: day,
                mouseDown: true,
            });
        }
    }

    handleDayMouseUp(day, modifiers) {
        this.setState({
            mouseDown: false,
        });

        const dateFilter = {
            after: moment(
                this.state.after > this.state.before
                    ? this.state.before
                    : this.state.after,
            )
                .startOf('day')
                .toISOString(),
            before: moment(
                this.state.after > this.state.before
                    ? this.state.after
                    : this.state.before,
            )
                .endOf('day')
                .toISOString(),
        };
        this.onFilterChange(dateFilter);
        this.dropDown.close();
    }

    handleSelectAllDates = () => {
        if (this.props.mode == 'payroll') {
            this.onFilterChange({
                before: 'all',
                after: moment('2010-01-01').toISOString(),
            });
        } else {
            this.onFilterChange({ before: 'all', after: 'all' });
        }
        const currentUrlParams = new URLSearchParams(history.location.search);
        currentUrlParams.set('getall', 1);
        this.dropDown.close();
    };

    handleSelectDateRange(after, before) {
        const dateFilter = {
            after: moment(after)
                .startOf('day')
                .toISOString(),
            before: moment(before)
                .endOf('day')
                .toISOString(),
        };
        this.onFilterChange(dateFilter);
        this.dropDown.close();
    }

    render() {
        const { after, before } = this.state;
        const paramQuery = history.location.search;
        const from = after;
        const selectedDays = [from, { from, to: before }];
        const { daypicker } = this;
        const modifiers = {
            'selected-right': after > before ? after : before,
            'selected-left': after > before ? before : after,
            nextMonth: day => {
                if (daypicker) {
                    return moment(day).isAfter(
                        moment(daypicker.state.currentMonth),
                        'month',
                    );
                }
            },
            previousMonth: day => {
                if (daypicker) {
                    return moment(day).isBefore(
                        moment(daypicker.state.currentMonth),
                        'month',
                    );
                }
            },
        };

        const menuContent = () => (
            <div className="operations dropdown-menu">
                <div className="data-picker">
                    <DayPicker
                        ref={daypicker => {
                            this.daypicker = daypicker;
                        }}
                        locale="en-gb"
                        month={this.state.before}
                        className="Range"
                        numberOfMonths={1}
                        enableOutsideDays={true}
                        firstDayOfWeek={1}
                        modifiers={modifiers}
                        selectedDays={selectedDays}
                        onDayMouseEnter={this.handleDayMouseEnter}
                        onDayMouseDown={this.handleDayMouseDown}
                        onDayMouseUp={this.handleDayMouseUp}
                    />
                    {!this.props.hideOptions && (this.props.mode === 'payroll'
                        ? (<div className="date-options">
                            <div
                                className={`option ${
                                    this.getRangeSelection() == 'lastweek'
                                        ? 'selected'
                                        : ''
                                }`}
                                onClick={() =>
                                    this.handleSelectDateRange(
                                        moment()
                                            .subtract(1, 'weeks')
                                            .startOf('isoWeek'),
                                        moment()
                                            .subtract(1, 'weeks')
                                            .endOf('isoWeek'),
                                    )
                                }
                            >
                                Last week
                            </div>
                        </div>)
                        : (<div className="date-options">
                            <div
                                className={`option full ${
                                    this.getRangeSelection() == 'alldates'
                                        ? 'selected'
                                        : ''
                                }`}
                                onClick={() => this.handleSelectAllDates()}
                            >
                                All dates
                            </div>
                        <div
                            className={`option ${
                                this.getRangeSelection() == 'lastweek'
                                    ? 'selected'
                                    : ''
                            }`}
                            onClick={() =>
                                this.handleSelectDateRange(
                                    moment()
                                        .subtract(1, 'weeks')
                                        .startOf('isoWeek'),
                                    moment()
                                        .subtract(1, 'weeks')
                                        .endOf('isoWeek'),
                                )
                            }
                        >
                            Last week
                        </div>
                        <div
                            className={`option ${
                                this.getRangeSelection() == 'currentweek'
                                    ? 'selected'
                                    : ''
                            }`}
                            onClick={() =>
                                this.handleSelectDateRange(
                                    moment().startOf('isoWeek'),
                                    moment().endOf('isoWeek'),
                                )
                            }
                        >
                            This week
                        </div>
                        <div
                            className={`option ${
                                this.getRangeSelection() == 'lastmonth'
                                    ? 'selected'
                                    : ''
                            }`}
                            onClick={() =>
                                this.handleSelectDateRange(
                                    moment()
                                        .subtract(1, 'month')
                                        .startOf('month'),
                                    moment()
                                        .subtract(1, 'month')
                                        .endOf('month'),
                                )
                            }
                        >
                            Last month
                        </div>
                        <div
                            className={`option ${
                                this.getRangeSelection() == 'currentmonth'
                                    ? 'selected'
                                    : ''
                            }`}
                            onClick={() =>
                                this.handleSelectDateRange(
                                    moment().startOf('month'),
                                    moment().endOf('month'),
                                )
                            }
                        >
                            This month
                        </div>
                    </div>))}
                </div>
            </div>
        );
        return (
            <DropDown
                filterKey={this.props.filterKey}
                options={this.options}
                defaultSelection={this.defaultSelection}
                renderSelected={this.renderSelected}
                onFilterChange={this.props.onFilterChange}
                renderMenu={menuContent}
                large={true}
                ref={dropDown => (this.dropDown = dropDown)}
                className="date"
            />
        );
    }

    renderSelected = (value, isOpen) => (
        <div className="dropdown-placeholder">
            <span>{this.getSelectedDates()}</span>
        </div>
    );
}
